import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import FormGroupWrapper from "../Wrappers/FormGroupWrapper";
import { formGroupTextareaDefaultProps, formGroupTextareaPropTypes, renderFormGroupCommonPropTypes } from "../FormGroupCommonPropTypes";
var RenderTextarea = function RenderTextarea(props) {
  var input = props.input,
    autofocus = props.autofocus,
    placeholder = props.placeholder,
    rows = props.rows;
  return /*#__PURE__*/React.createElement(FormGroupWrapper, props, /*#__PURE__*/React.createElement("textarea", _extends({}, input, {
    className: "form-control",
    id: input.name,
    placeholder: placeholder,
    autoFocus: autofocus // eslint-disable-line jsx-a11y/no-autofocus
    ,
    rows: rows
  })));
};
RenderTextarea.propTypes = _objectSpread(_objectSpread({}, renderFormGroupCommonPropTypes), formGroupTextareaPropTypes);
RenderTextarea.defaultProps = _objectSpread({}, formGroupTextareaDefaultProps);
export default RenderTextarea;